
export const displayTypes = [
    { val: 1, name: 'Modal popup with history', description: '' },
    { val: 2, name: 'Toast', description: '' },
    { val: 3, name: 'Banner', description: '' },
];

export const displayTypeToName = (displayType) => ko.pureComputed(() => {
    const dt = displayTypes.filter(i => i.val == ko.unwrap(displayType))[0];

    return dt ? dt.name : 'unknown';
});